// import { useAppRealtime } from '../../websocket/useAppRealtime'

// export default function AppRealtimeRunner() {

//   useAppRealtime()

//   return null
// }

import { useDynamicRealtimeSubscriptions } from '../../websocket/useDynamicRealtimeSubscriptions';

export default function AppRealtimeRunner() {
  useDynamicRealtimeSubscriptions();

  return null;
}
